'use strict';


import { Report } from './QAReport';
import { threeJsVariables } from '../../settings';
import { MathUtils } from 'three';

export class PoiQA extends Report{
	constructor () {
		super('Poi');
		this.message = 'Invalid poi rotation';
		this.compass = config.threejs.compass.correction;
	}

	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}

		new Promise(resolve => {
			let poiGroup;
			const interval = setInterval(() => {
				poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
				if (poiGroup) {
					clearInterval(interval);
					resolve(poiGroup)
				}
			},200)
		}).then(poiGroup => {
			const currentRotation = MathUtils.radToDeg(poiGroup.rotation.y);
			const expectedRotation = MathUtils.radToDeg(this.compass - Math.PI / 2);
			if (currentRotation !== expectedRotation) {
				this.addError(currentRotation,`Current rotation ${currentRotation} deg. Expected rotation ${expectedRotation} deg.`,expectedRotation);
			}

			const poiData = config.poiData.filter(poi => poi.orbit === 1);
			if (poiData.length) {
				const moreThan400Meters = poiData.filter(poi => poi.distance > 400);
				if (moreThan400Meters.length) {
					moreThan400Meters.forEach(poi => {
						const name = poi.name.find(names => names.lang === 'en') || {value: poi.id};
						this.addError(poi,`Distance to point "${name.value}" more than 400m.`,'<= 400')
					});
				}
			}

			this.normalize();
			this.showReport();
		});
	}

	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => this.jsonReport.push(errorData.message));
		}
	}

}
